import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Обработчик загрузки Яндекс.Карт 3.0
window.addEventListener('load', () => {
  if (window.ymaps3) {
    window.dispatchEvent(new Event('ymaps3_loaded'));
  }
});

// Функция для создания корневого элемента и монтирования React
const initReactApp = () => {
  let rootElement = document.getElementById('react-modal-root');
  if (!rootElement) {
    rootElement = document.createElement('div');
    rootElement.id = 'react-modal-root';
    document.body.appendChild(rootElement);
  }

  const root = ReactDOM.createRoot(rootElement);
  root.render(<App />);
};

// Ждем загрузки DOM
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initReactApp);
} else {
  // DOM уже загружен
  initReactApp();
}
